import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { CertificateOption, WorkFormContext } from '../work-form.types';

export type VisibilityRuleDependencies = {
  defaultValues: Partial<WorkFormContext> | undefined;
  departmentId: string | undefined;
  isFreelance: boolean | undefined;
  isTempwork: boolean | undefined;
  selectedStartDate: string | undefined;
  selectedEndDate: string | undefined;
  selectedStartTime: string | undefined;
  selectedEndTime: string | undefined;
  selectedCertificates: CertificateOption[];
};
export const useFormVisibilityRules = (dependencies: VisibilityRuleDependencies) => {
  const { setValue } = useFormContext<WorkFormContext>();
  const {
    defaultValues,
    departmentId,
    selectedStartDate,
    selectedEndDate,
    selectedStartTime,
    selectedEndTime,
  } = dependencies;

  const isMounted = useRef(true);

  useEffect(() => {
    // Skip the first useEffect call because of mounting
    if (isMounted.current) {
      isMounted.current = false;
      return;
    }
    setValue('visibilityRules', []);
  }, [selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime]);
  useEffect(() => {
    const defaultsHaveNoVisibilityRules = !defaultValues?.visibilityRules;
    const hasDepartmentChanged = departmentId !== defaultValues?.department;

    if (defaultsHaveNoVisibilityRules || hasDepartmentChanged) {
      setValue('visibilityRules', []);
    }
  }, [departmentId, setValue]);
};
